module.exports = __webpack_public_path__ + "img/landing-page-image.e73a118.png";